import {beep, custom, getParameter, handleInput, showMessageError} from "../../classes/functions"
import {createRef, useEffect, useState} from "react";
import {toast} from "react-toastify";
import {BsFillEraserFill} from 'react-icons/bs';
import './index.css';
import api from "../../config";
import Header from "../../components/Header";
import Division from "../../components/Division";
import Lateral from "../../components/Lateral";
import ReactTooltip from "react-tooltip";
import {FaCog} from "react-icons/fa";
import {AiFillCheckCircle} from 'react-icons/ai'
import ModalConfirmation from "../../components/Modal/ModalConfirmation";
import ReactModal from "react-modal";
import ModalError from "../../components/Modal/ModalError";

export default function SeparationConference() {
    const [requestIsConfirmed, setRequestIsConfirmed] = useState(false);
    const [showSeparateQuantity, setShowSeparateQuantity] = useState(getParameter('Mostrar Quantidade Separada'));
    const [listOrders, setListOrders] = useState([]);
    const [listUnits, setListUnits] = useState([]);
    const [cancelToken, setCancelToken] = useState(null);
    const [carrying, setCarrying] = useState(false);
    const [requests, setRequests] = useState({});
    const getOrderByIdOrDocument = getParameter('TIPO_BUSCA_PEDIDO') || 'numero_documento';
    const [currentRequestItem, setCurrentRequestItem] = useState({});
    const [errorMessage, setErrorMessage] = useState('');
    const [totalQuantity, setTotalQuantity] = useState(0);
    const [insertedQuantity, setInsertedQuantity] = useState(0);
    const [currentOrder, setCurrentOrder] = useState(0);
    const [showModals, setShowModals] = useState({
        showCleanAllModal: false,
        showCleanOneModal: false,
        showFinishModal: false,
        showQuantityTypeModal: false,
        showFinishedQuantityModal: false,
        showReleaseRequestModal: false,
        showErrorModal: false
    });
    const [inputsConferences, setInputsConference] = useState({
        pedido: '',
        produto: '',
        unidadeMedida: '',
        quantidade: ''
    });
    const inputProduct = createRef();

    function getProductsRequests() {
        let currentOrderExistsAndIsSeparatedStatus = (currentOrder !== 0);
        let newTotalQuantityValue = 0;
        let newInsertedQuantityValue = 0;
        let productWithoutCodeRepetions = [];

        if (currentOrderExistsAndIsSeparatedStatus) {
            if (parseInt(inputsConferences?.pedido?.split(' -')[0]) && currentOrder !== 0) {
                return api
                    .get(`/api/products_requests/${parseInt(currentOrder)}`)
                    .then((response) => {
                        inputProduct?.current?.focus();

                        if (response?.data?.status !== "006" && response?.data?.status !== "011") {
                            setErrorMessage('Este pedido não está com status SEPARADO ou EM SEPARAÇÃO.');
                            setRequests([]);

                            return false;
                        }

                        response.data.itens.map((data) => {
                            let codeAlreadyExistsInArray = false;

                            data.quantidade = parseInt(data.quantidade);
                            data.qtde_separada = parseInt(data.qtde_separada);
                            data.qtde_conferida = parseInt(data.qtde_conferida);

                            productWithoutCodeRepetions.map((product) => {
                                if(parseInt(data.id_produto) === parseInt(product.id_produto)){
                                    product.quantidade += data.quantidade;
                                    codeAlreadyExistsInArray = true;
                                }

                                return product;
                            });

                            if(!codeAlreadyExistsInArray){
                               return productWithoutCodeRepetions.push(data); 
                            }
                        });

                        response.data.itens = productWithoutCodeRepetions;

                        response?.data?.itens?.map((row) => {
                            newTotalQuantityValue += row.quantidade;
                            newInsertedQuantityValue += row.qtde_conferida;
                        });

                        setTotalQuantity(newTotalQuantityValue);
                        setInsertedQuantity(newInsertedQuantityValue);
                        
                        setRequests(response.data);

                        return true;
                    })
                    .catch((error) => {
                        setRequests([]);
                        if (error?.response?.data?.message) {
                            return setErrorMessage(error?.response?.data?.message);
                        }

                        if(error?.response?.data?.error?.message){
                            return setErrorMessage(error?.response?.data?.error?.message);
                        }

                        console.log(error);

                        return setErrorMessage('Ops! Ocorreu um erro.');
                    });
            }

            return true;
        }

        return setErrorMessage('Este pedido não existe.');
    }

    function checkProductAndInsertQuantity(e) {
        if (e.key === 'Enter') {
            let barcodeExistsInOrder = false;
            
            const addNewErrorMessage = (arrayOfErrorMessages, errorMessage) => {
                arrayOfErrorMessages.push(errorMessage);

                return errorMessage;
            };

            let errorMessages = [];

            if (!inputsConferences?.produto) {
                setErrorMessage(addNewErrorMessage(errorMessages, "Por favor, insira um produto."));
                beep();

                return false;
            }

            requests?.itens?.map((request, index) => {
                request?.produto?.codigos_barra?.map((barcode) => {
                    if (barcode?.codigo_barra === inputsConferences?.produto && request?.id_produto === barcode?.produto) { 
                        barcodeExistsInOrder = true;

                        if(request?.qtde_conferida + barcode?.quantidade > request?.quantidade){
                            setErrorMessage(addNewErrorMessage(errorMessages, "A quantidade conferida não pode ser maior que a quantidade separada."));
                            beep();
                            return setInputsConference((prevState) => ({...prevState, produto: ''}));
                        }

                        requests.itens?.splice(index, 1);
                        requests.itens?.unshift(request);

                        request.qtde_conferida += barcode.quantidade;
                        setInsertedQuantity(insertedQuantity + barcode.quantidade);

                        setRequests(requests);

                        return api
                               .post('/api/products_requests/setCheckItem', {
                                    id: request.id, qtde_conferida: barcode.quantidade, status: requests.status
                               })
                               .then((response) => {
                                    
                               })
                               .catch((error) => {
                                    console.log(error);
                               });
                    }

                    return true;
                });

                return request;
            });

            setInputsConference((prevState) => ({...prevState, produto: ''}));

            if(!barcodeExistsInOrder){
                return verifyBarcode(inputsConferences.produto);
            }

            setRequests(requests);

            if (verifyQuantities() && errorMessage.length !== 0 && getParameter('AVISA_CONFERENCIA_FINALIZADA')) {
                setShowModals((prevState) => ({...prevState, showFinishedQuantityModal: true}));
            }

            return true;
        }
    }

    function releaseRequest(){
        api
        .get(`/api/products_requests/setReleaseConferenceRequest/${parseInt(currentOrder)}`)
        .then(() => {
            setInputsConference((prevState) => ({...prevState, pedido: ''}));
            setRequests({});
        })
        .catch((error) => {
            console.log(error);
        });
    }

    function getUnits() {
        api.get("/api/generics/getItens?table=VL")
            .then((response) => {
                setListUnits(response.data);
            }).catch((error) => {
            showMessageError(error.response.data);
        });
    }

    function getOrders(inputOrder) {
        let data = {
            data: {
                page: 1,
                qtdePage: 50,
                typeSearch: getOrderByIdOrDocument,
                termSearch: inputOrder?.split(' -')[0]
            }
        }

        api
            .post('/api/product_requests/getSearch', data)
            .then((response) => {
                let listOrdersWithSeparateStatus = [];

                response.data.dados.map((dado) => {
                    if (dado.status === "006" || dado.status === "011") {
                        listOrdersWithSeparateStatus.push(dado);
                    }
                });
                
                setListOrders(listOrdersWithSeparateStatus);

                if(listOrdersWithSeparateStatus.length === 1){
                    setCurrentOrder(listOrdersWithSeparateStatus[0]?.id);
                }
            })
            .catch((error) => {
                console.log(error);
                setErrorMessage('Ops! Ocorreu um erro.');

                setCarrying(false);
            });
    }

    function cleanAll() {
        api
        .get(`/api/products_requests/setClearConference/${parseInt(currentOrder)}`)
        .then(() => {
            return getProductsRequests();
        })
        .catch((error) => {
            return console.log(error);
        });

        setShowModals((prevState) => ({...prevState, showCleanAllModal: false}));
    }

    function cleanOne(id) {
        api
        .get(`/api/products_requests/setClearItemConference/${id}`)
        .then(() => {
            return getProductsRequests();
        })
        .catch((error) => {
            return console.log(error);
        });
    }

    function selectList(setList, input, value) {
        setInputsConference((prevState) => ({...prevState, [input]: value}));
        setList([]);
    }

    function verifyQuantities() {
        if (totalQuantity !== 0 && totalQuantity === insertedQuantity) {
            return true;
        }

        return false;
    }

    function finishConference() {
        if(inputsConferences.unidadeMedida && inputsConferences.quantidade){
            setShowModals((prevState) => ({...prevState, showQuantityTypeModal: false})); 

            let data = {
                volume: parseInt(inputsConferences?.quantidade),
                tipo_volume: inputsConferences?.unidadeMedida,
                itens: requests?.itens
            }
    
            setCarrying(true);

            //API original: `/api/products_requests/${parseInt(currentOrder)}/finalizaConferencia`
            //API para o futuro: `/api/products_requests/${parseInt(currentOrder)}/finalizarConferencia`
    
            return api
                    .put(`/api/products_requests/${parseInt(currentOrder)}/finalizarConferencia`, data, {Accept: 'application/json'})
                    .then((response) => {
                        setCarrying(false);
                        toast.success('Conferência gravada com sucesso!');
                        setRequests({});
                        setInputsConference((prevState) => ({...prevState, quantidade: '', pedido: ''}));
                    })
                    .catch((error) => {
                        const responseError = error?.response?.data;
                        setErrorMessage(responseError.info ?? responseError.message);
                        setCarrying(false);
                    });
        }
        
        return toast.error('Preencha todos os valores solicitados.');
    }

    function verifyBarcode(barcode){
        api
        .get(`/api/barcodes/${barcode}`)
        .then((response) => {
            if(response.data.id){
                setErrorMessage("O código de barra não pertence a este pedido");

                return beep();
            }
        })
        .catch((error) => {
            setErrorMessage(error?.response?.data?.message);
            beep();
        });
    }

    useEffect(() => {
        getUnits();
    }, [showModals?.showQuantityTypeModal]);

    useEffect(() => {
        return () => {
            if (cancelToken) {
                cancelToken.cancel('Componente desmotando');
            }
        }
    }, [cancelToken]);

    useEffect(() => {
        if (showModals.showFinishedQuantityModal) {
            setTimeout(() => {
                setShowModals((prevState) => ({...prevState, showFinishedQuantityModal: false}));
            }, [1500]);
        }
    }, [showModals?.showFinishedQuantityModal]);

    useEffect(() => {
        if (errorMessage) {
            setShowModals((prevState) => ({...prevState, showErrorModal: true}));
        }
    }, [errorMessage]);

    useEffect(() => {
        if (!showModals.showErrorModal) {
            setErrorMessage('');
        }
    }, [showModals.showErrorModal]);

    return (
        <div>
            <Header/>
            <Division/>
            <Lateral/>
            <ReactTooltip/>

            <ModalConfirmation state={showModals.showCleanAllModal} setState={setShowModals} stateName={'showCleanAllModal'} custom={custom('500px', '250px')} title={'Deseja realmente limpar tudo'} action={cleanAll} param={''}/>
            <ModalConfirmation state={showModals.showFinishModal} setState={setShowModals} stateName={'showFinishModal'} custom={custom('500px', '250px')} title={'Deseja realmente finalizar'} action={cleanAll} param={''}/>
            <ModalConfirmation state={showModals.showCleanOneModal} setState={setShowModals} stateName={'showCleanOneModal'} custom={custom('500px', '250px')} title={`Deseja realmente limpar a quantidade do produto ${currentRequestItem?.produto?.descricao}`} action={cleanOne} param={currentRequestItem?.id}/>
            <ModalConfirmation state={showModals.showReleaseRequestModal} setState={setShowModals} stateName={'showReleaseRequestModal'} custom={custom('500px', '250px')} title={`Deseja realmente liberar a requisição ${currentOrder}`} action={releaseRequest} />
            <ModalError state={showModals.showErrorModal} setState={setShowModals} stateName={'showErrorModal'} custom={custom('33%', '25%')} error={errorMessage}/>

            <ReactModal
                isOpen={showModals?.showQuantityTypeModal}
                onRequestClose={() => setShowModals((prevState) => ({...prevState, showQuantityTypeModal: false}))}
                overlayClassName="modal-overlay"
                className="modal-volume"
            >
                <h1 className="modal__title">Informar Volumes</h1>
                <div className="separation-conference__column">
                    <div className="separation-conference___row separation-conference___labels">
                        <label className="separation-conference____label" style={{width: '150px'}}>Tipo de volume:</label>
                        <label className="separation-conference____label">Quantidade:</label>
                    </div>
                    <div className="separation-conference___row formDiv">
                        <select onChange={(e) => setInputsConference((prevState) => ({...prevState, unidadeMedida: e.target.value}))}>
                            <option value="">Selecione</option>
                            {listUnits.map((listUnit, index) => {
                                return (
                                    <option key={index} value={listUnit?.id}>{listUnit?.descricao}</option>
                                )
                            })}
                        </select>
                        <input type="text" className="separation-conference____input" value={inputsConferences?.quantidade?.replace(/[^\d]/g, '')} onChange={(e) => setInputsConference((prevState) => ({...prevState, quantidade: e.target.value?.replace(/[^\d]/g, '')}))} placeholder="Inserir quantidade"/>
                    </div>
                </div>
                <div className="separation-conference___row" style={{flexDirection: 'row'}}>
                    <button type="button" className="buttonInsert separation-conference____button" onClick={() => {setShowModals((prevState) => ({...prevState, showQuantityTypeModal: false})); setInputsConference((prevState) => ({...prevState, quantidade: ''}))}}>Fechar</button>
                    <button type="button" className="buttonInsert separation-conference____button" onClick={finishConference}>Confirmar</button>
                </div>
            </ReactModal>
            
            <ReactModal
                isOpen={showModals?.showFinishedQuantityModal}
                onRequestClose={() => setShowModals((prevState) => ({...prevState, showFinishedQuantityModal: false}))}
                overlayClassName="modal-overlay"
                style={custom('500px', '250px')}
            >
                <div className="finish-modal">
                    <div className="finish-modal__header">
                        <AiFillCheckCircle className="finish-modal___icon"/>
                        <h1 className="finish-modal___title modal__title">Conferência finalizada!</h1>
                    </div>
                    <button type="button" className="finish-modal__button" onClick={() => setShowModals((prevState) => ({...prevState, showFinishedQuantityModal: false}))}>Fechar</button>
                </div>
            </ReactModal>

            {carrying && <div className="content">
                <div className="divCarrying">
                    <span>Carregando..</span>
                    <FaCog icon="spinner" className="spinner"/>
                </div>
            </div>}

            {!carrying && <div className="content">
                <div className="container">
                    <div className="separation-conference__header">
                        <h1 className="separation-conference___title title">Conferência de Separação</h1>
                        <div className="separation-conference____buttons">
                            {requests?.id && <button type="submit" className="buttonInsert" onClick={() => setShowModals((prevState) => ({...prevState, showCleanAllModal: true}))}>Limpar tudo</button>}
                            {requests?.id && <button type="submit" className="buttonInsert" id="releaseRequest" style={{width: "100%"}} onClick={() => setShowModals((prevState) => ({...prevState, showReleaseRequestModal: true}))}>Liberar requisição</button>}
                            {verifyQuantities() && <button type="submit" className="buttonInsert" onClick={() => setShowModals((prevState) => ({...prevState, showQuantityTypeModal: true}))}>Finalizar</button>}
                        </div>
                    </div>
                    <div className="separation-conference__column">
                        <div className="separation-conference___row separation-conference___labels">
                            <label className="separation-conference____label" style={{fontWeight: `${requestIsConfirmed ? '400' : '700'}`}}>Pedido:</label>
                            <label className="separation-conference____label" style={{fontWeight: `${requestIsConfirmed ? '700' : '400'}`}}>Produto(CODBAR):</label>
                        </div>
                        <div className="separation-conference___row" id="separation-conference___row-input">
                            <div>
                                <input type="text" autoComplete="off" style={{width: '100%'}} className="separation-conference____input" value={inputsConferences.pedido} name="pedido" onKeyDown={(e) => e.key === "Enter" && currentOrder !== 0 && getProductsRequests()} onChange={(e) => {handleInput(setInputsConference, e); getOrders(e.target.value)}} placeholder="Inserir número de pedido"/>
                                <ul style={{width: '20%'}} className="dropdown-menu" id="transportDatalist">
                                    {listOrders?.map((listOrder, index) => {
                                        if (listOrder[getOrderByIdOrDocument]) {
                                            return (
                                                <li key={index} onClick={() => {
                                                    selectList(setListOrders, 'pedido', `${listOrder[getOrderByIdOrDocument]} - ${listOrder?.cliente}`);
                                                    setCurrentOrder(listOrder.id)
                                                }}>
                                                    <a>{listOrder[getOrderByIdOrDocument]} - {listOrder?.cliente}</a>
                                                </li>
                                            );
                                        }
                                    })}
                                </ul>
                            </div>
                            <input type="text" className="separation-conference____input" value={inputsConferences.produto} onKeyDown={checkProductAndInsertQuantity} onChange={(e) => setInputsConference((prevState) => ({...prevState, produto: e.target.value}))} placeholder="Inserir código de barras" ref={inputProduct} />
                        </div>
                        <div className="separation-conference___row">
                            <button type="button" className="buttonInsert separation-conference____button" onClick={getProductsRequests} style={{height: 'inherit'}}>Confirmar</button>
                        </div>
                    </div>
                    <div className="formDiv" style={{marginTop: '1rem'}}>
                        {requests?.id &&
                            <table>
                                <thead>
                                <tr>
                                    <th>Código</th>
                                    <th>Descrição</th>
                                    {showSeparateQuantity && showSeparateQuantity !== 'F' && <th>Qtde Sep.</th>}
                                    <th>Qtde Conf.</th>
                                    <th>Ações</th>
                                </tr>
                                </thead>
                                <tbody>
                                {requests?.itens?.map((request, index) => {
                                    return (
                                        <tr id={request.id} key={index}>
                                            <td>{request?.produto?.codigo_produto}</td>
                                            <td style={{textAlign: 'left'}}>{request?.produto?.descricao}</td>
                                                {showSeparateQuantity && showSeparateQuantity !== 'F' &&
                                            <td>{request?.quantidade}</td>}
                                            <td>{request?.qtde_conferida}</td>
                                            <td><BsFillEraserFill id="separation-conference-eraser" onClick={() => {
                                                setCurrentRequestItem(request);
                                                setShowModals((prevState) => ({...prevState, showCleanOneModal: true}))
                                            }}/></td>
                                        </tr>
                                    )
                                })}
                                </tbody>
                            </table>
                        }
                    </div>
                </div>
            </div>}
        </div>
    )
}